// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wp1r","colBig":"styles_colBig__3NzkS","colSmall":"styles_colSmall__3tePz"};